module.exports = __webpack_public_path__ + "img/invoice_empty.cda763cd.png";